import Phaser from "phaser"
import { calculateScaleFactor } from "../config/scaling"
import {
	checkLocalSavedData,
	destroyInstructions,
	displayInstructions,
} from "../helpers/levelManager"
import {
	updateMiniLevel,
	destroyTooltip,
	displayTooltip,
	displayIndicator,
	handleGameProgressUpdate,
	displayTutorialHand
} from "../helpers/levelManager"
import { playUISound } from "./levelManager"
export default class TabletViewUI extends Phaser.Scene {
	constructor() {
		super({ key: "TabletUI" })
	}

	init() {
		// Initialize any properties needed
		this.savedUserData = null
		this.savedLevel = 0
		this.savedMiniLevel = 0

		// Game dimensions and scaling
		this.gameW = this.cameras.main.width
		this.gameH = this.cameras.main.height

		// Get scaling information
		const scalingData = calculateScaleFactor(this)
		this.scaleFactor = scalingData.scaleFactor
		this.safeZoneX = scalingData.safeZoneX
		this.safeZoneY = scalingData.safeZoneY
		this.safeZoneWidth = scalingData.safeZoneWidth
		this.safeZoneHeight = scalingData.safeZoneHeight
		this.templateY = scalingData.templateY

		// Responsive font sizing
		this.baseFontSize = 20
		this.fontSize = this.baseFontSize * this.scaleFactor

		this.tabletScene = this.scene.get("TabletScene")

		this.loadSavedData()
	}

	loadSavedData() {
		this.savedUserData = checkLocalSavedData()
		this.savedLevel = this.savedUserData?.userLevel || 0
		this.savedMiniLevel = this.savedUserData?.userMiniLevel || 0
		this.currentPlanet = this.savedUserData?.currentPlanet || 0
		this.alertsOpened = this.savedUserData?.alertsOpened || {}
	}

	create() {
		this.createCloseButton()
	}

	createCloseButton() {
		this.closeTabletButton = this.add
			.image(
				this.tabletScene.tabletView.x - 350 * this.tabletScene.scaleFactor,
				this.tabletScene.tabletView.y + 130 * this.tabletScene.scaleFactor,
				"closeTabletButton",
			)
			.setScale(0, 0)
			.setInteractive()

		this.closeTabletButton.on("pointerdown", () => {
			this.ambianceSound = this.sound
				.add("put-away-tablet", {
					volume: 2.5,
					loop: false,
				})
				.play()

			let cockpitScene = this.scene.get("CockpitScene")
			let creatureDatabase = this.scene.get("CreatureDatabase")
			let fieldGuide = this.scene.get("FieldGuide")
			let alertScene = this.scene.get("Alerts")
			let helpDeskScene = this.scene.get("HelpDesk")

			if (helpDeskScene.searchInputElement) {
				helpDeskScene.searchInputElement.remove()
			}

			if (helpDeskScene.clearButton) {
				helpDeskScene.clearButton.remove()
			}

			if (alertScene.wifiPasswordReference) {
				alertScene.wifiPasswordReference.remove()
			}

			// if (cockpitScene.instructionBg)
			// 	cockpitScene.instructionBg.setVisible(true)
			// if (cockpitScene.instructionText)
			// 	cockpitScene.instructionText.setVisible(true)
			destroyInstructions(cockpitScene)

			console.log(
				"Current Planet:",
				this.currentPlanet + ", Saved Mini Level:",
				this.savedMiniLevel,
			)

			if (this.currentPlanet === 1 && this.savedMiniLevel === 4) {
				cockpitScene.backButton.input.enabled = true
				cockpitScene.backButton.setAlpha(1)
				cockpitScene.frontButton.input.enabled = true
				cockpitScene.frontButton.setAlpha(1)
			}

			if (this.currentPlanet === 1 && this.savedMiniLevel === 11) {
				console.log("Planet 1 Alert Check")
				handleGameProgressUpdate(cockpitScene)
			}

			if (this.currentPlanet === 1 && this.savedMiniLevel === 13) {
				console.log("Planet 1 Alert Check")
				handleGameProgressUpdate(cockpitScene)
			}

			// if (this.currentPlanet === 2 && this.savedMiniLevel === 13) {

			// 	cockpitScene.creature3Panel()
			// }

			if (this.currentPlanet === 2 && this.savedMiniLevel === 5) {

				this.tabletScene.removeNotification()
				cockpitScene.removeNotification()
				this.tabletScene.removeUnlockAnim()

				displayInstructions(
					cockpitScene,
					"Press the left and right arrow buttons to go to the next creature",
					14,
					500,
					60,
				)
			}

			if (this.currentPlanet === 2 && this.savedMiniLevel === 13) {

				this.tabletScene.removeNotification()
				//cockpitScene.creature3Panel()
				this.tabletScene.removeUnlockAnim()				
			}

			if (this.currentPlanet === 3 && this.savedMiniLevel === 1) {
				console.log("Is Connected Alert Done?")
				this.loadSavedData()
				let alertsOpened = this.alertsOpened
				console.log("Alerts opened", alertsOpened)

				let allAlerts = ["reconnectDevice"]

				let unopenedAlerts = allAlerts.filter((alert) => !alertsOpened[alert])

				if (unopenedAlerts.length === 0) {
					console.log("Proceed to scanning")
					updateMiniLevel(this.savedMiniLevel)
					handleGameProgressUpdate(cockpitScene)
				} else {
					console.log("Unopened alerts blocking", unopenedAlerts)
					//unopenedAlerts.forEach((alert, index) => this.createAlert(alert, index));
				}
			}

			if (this.currentPlanet === 3 && this.savedMiniLevel === 9) {
				// displayInstructions(
				// 	cockpitScene,
				// 	"Press the left and right arrow buttons to go to the next creature",
				// 	14,
				// 	500,
				// 	60,
				// )
				if (cockpitScene.notificationBell) {
					cockpitScene.notificationBell.destroy()
				}
			}

			if (this.currentPlanet === 2 && this.savedMiniLevel === 17) {
				console.log("End of Planet Check Stuff Tablet Closed")
				this.loadSavedData()
				let alertsOpened = this.alertsOpened
				console.log("Alerts opened", alertsOpened)

				let allAlerts = ["securityCheck", "restartDevice"]

				let unopenedAlerts = allAlerts.filter((alert) => !alertsOpened[alert])

				if (unopenedAlerts.length === 0) {
					console.log("No unopened alerts blocking show Launch")
					cockpitScene.updateNavigationInstructions()
				} else {
					console.log("Unopened alerts blocking", unopenedAlerts)
					//unopenedAlerts.forEach((alert, index) => this.createAlert(alert, index));
				}
			}
			if (this.currentPlanet === 3 && this.savedMiniLevel === 5) {
				this.loadSavedData()
				let robotAlertOpened = this.alertsOpened["robotAlert"]
				if (robotAlertOpened) {
					displayInstructions(
						cockpitScene,
						"This is Tube 1, one of your creature care stations.\nYou’ll feed and observe your new alien friends right here.",
						12,
						400,
						60,
					)
				}
			}

			if (this.currentPlanet === 3 && this.savedMiniLevel === 16) {
				console.log("End of Creature 2 Check Stuff Tablet Closed")
				this.loadSavedData()
				let alertsOpened = this.alertsOpened
				console.log("Alerts opened", alertsOpened)

				let allAlerts = ["otpAlert", "reconnectDevice", "robotAlert"]

				let unopenedAlerts = allAlerts.filter((alert) => !alertsOpened[alert])

				if (unopenedAlerts.length === 0) {
					console.log("No unopened alerts blocking show Launch")
					//cockpitScene.updateNavigationInstructions()
					destroyInstructions(cockpitScene)
				} else {
					console.log("Unopened alerts blocking", unopenedAlerts)
					//unopenedAlerts.forEach((alert, index) => this.createAlert(alert, index));
				}
			}

			if (this.currentPlanet === 3 && this.savedMiniLevel === 20) {
				cockpitScene.foodLabel.setVisible(true)
				cockpitScene.taskHeader02.setVisible(true)
				console.log("Show Planet 3 Creature 2 Food Stuff")
			}

			if (this.currentPlanet === 3 && this.savedMiniLevel === 23) {
				console.log("End of Planet Check Stuff Tablet Closed")
				this.loadSavedData()
				let alertsOpened = this.alertsOpened
				console.log("Alerts opened", alertsOpened)

				let allAlerts = ["otpAlert", "reconnectDevice", "robotAlert"]

				let unopenedAlerts = allAlerts.filter((alert) => !alertsOpened[alert])

				if (unopenedAlerts.length === 0) {
					console.log("No unopened alerts blocking show Launch")
					cockpitScene.updateNavigationInstructions()
				} else {
					console.log("Unopened alerts blocking", unopenedAlerts)
					//unopenedAlerts.forEach((alert, index) => this.createAlert(alert, index));
				}
			}

			//destroyTooltip(cockpitScene);
			destroyTooltip(this)
			if (this.tabletBar) {
				this.tabletBar.destroy()
			}
			if (this.battery) {
				this.battery.destroy()
			}
			if (this.wifiOn) {
				this.wifiOn.destroy()
			}
			if (this.signal) {
				this.signal.destroy()
			}
			if (this.bluetooth) {
				this.bluetooth.destroy()
			}
			if (this.timeText) {
				this.timeText.destroy()
			}
			if (this.dateText) {
				this.dateText.destroy()
			}

			if (this.currentPlanet === 1 && this.savedMiniLevel === 11) {
			} else {
				//	destroyTooltip(cockpitScene)
			}

			// Close the current scene and return to the previous scene
			if (this.scene.isActive("CreatureDatabase")) {
				if (creatureDatabase.dropdownElement)
					creatureDatabase.dropdownElement.remove()
				if (creatureDatabase.numberInputElement)
					creatureDatabase.numberInputElement.remove()
				if (creatureDatabase.requiredTextElement)
					creatureDatabase.requiredTextElement.remove()
				if (creatureDatabase.dropdownElement2)
					creatureDatabase.dropdownElement2.remove()
				if (creatureDatabase.numberInputElement2)
					creatureDatabase.numberInputElement2.remove()
				if (creatureDatabase.requiredTextElement2) {
					creatureDatabase.requiredTextElement2.remove()
				}
				if (creatureDatabase.addEntry) creatureDatabase.addEntry.destroy()
				if (creatureDatabase.addEntryText)
					creatureDatabase.addEntryText.destroy()

				creatureDatabase.entryCount = 1
				// Remove any other HTML elements that might have been created
				const styles = document.getElementById("creature-form-styles")
				if (styles) styles.remove()

				destroyTooltip(creatureDatabase)
				creatureDatabase.removeScrollPanel()
				this.scene.stop("CreatureDatabase")
			}

			if (this.scene.isActive("FieldGuide")) {
				destroyTooltip(fieldGuide)
				fieldGuide.inputField.remove()
				if (fieldGuide.clearButton) fieldGuide.clearButton.remove()
				this.scene.stop("FieldGuide")
			}

			if (this.scene.isActive("Emails")) {
				destroyTooltip(creatureDatabase)
				this.scene.stop("Emails")
			}
			if (this.scene.isActive("Alerts")) {
				destroyTooltip(creatureDatabase)
				alertScene.removeHtmlItems()
				this.scene.stop("Alerts")
			}

			if (this.scene.isActive("HelpDesk")) {
				destroyTooltip(helpDeskScene)
				this.scene.stop("HelpDesk")
			}

			this.scene.stop("TabletScene")
			this.scene.stop("TabletUI")

			this.scene.resume("CockpitScene")
			//this.scene.resume('PreviousScene'); // Replace 'PreviousScene' with the actual scene name you want to return to

			this.loadSavedData()

			// if (this.currentPlanet === 10 && this.savedMiniLevel === 5) {
			// 	updateMiniLevel(this.savedMiniLevel)
			// 	this.loadSavedData()
			// }

			// if (this.savedLevel === 0 && this.savedMiniLevel === 6) {
			//     updateMiniLevel(this.savedMiniLevel);
			//     this.loadSavedData();
			// }

			//this.handleGameProgressUpdate(cockpitScene);
		})

		this.animateCloseButton(this.closeTabletButton)
	}

	displayTool() {
		console.log("Display Tool Tip Close")
		let wrapWidth = 0
		if (this.sys.game.device.os.desktop || this.sys.game.device.os.laptop) {
			wrapWidth = 1
		} else {
			wrapWidth = 1
		}
		//displayTooltip(this, this.closeTabletButton.x, this.closeTabletButton.y - 100 * this.scaleFactor, 'small', 'Up', 'Now that you know what your creature eats, you can close the tablet and feed them!', 12)
		displayTooltip(this, {
			xPos: this.closeTabletButton.x,
			yPos: this.closeTabletButton.y - 100 * this.scaleFactor,
			type: "closeFieldGuideTip",
			scale: 1,
			text: "Now that you know\nwhat your creature\neats, you can close\nthe tablet and\nfeed them!",
			fontScale: -8,
			xTextOffset: 0,
			yTextOffset: -3,
			wrapWidth: wrapWidth,
		})
	}

	displayInd() {
		displayIndicator(
			this,
			this.closeTabletButton.x,
			this.closeTabletButton.y - 4 * this.scaleFactor,
			1,
			"closeTabletIndicator",
		)
	}

	animateCloseButton(closeTabletButton) {
		this.tweens.add({
			targets: closeTabletButton,
			scale: this.tabletScene.scaleFactor * 0.55,
			duration: 600,
			ease: "Back.out",
		})

		// this.tweens.add({
		//     targets: closeTabletText,
		//     scale: tabletScene.scaleFactor * 1,
		//     duration: 1000,
		//     ease: 'Back.out'
		// });
	}

	closeButtonHandPointer() {
		// displayTutorialHand(this, {
		// 	xPos: this.closeTabletButton.x + 100 * this.scaleFactor,
		// 	yPos: this.closeTabletButton.y - 100 * this.scaleFactor,
		// 	rotation: -135,
		// })
	}
}
